<template>
  <div v-if="product" data-cy="product-gallery" class="product-view-grid relative lg:flex-row">
    <div class="hidden lg:block gap-y-4">
      <div class="ProductThumbnails">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="[ bg-white gap-y-5 ] mr-2 lg:mr-0 cursor-pointer overflow-hidden border mb-2.5 rounded-[14px]"
          :class="{
            'p-1 border border-primary-1-100': item.index === selected.index,
          }"
        >
          <NuxtImg
            v-if="item.url"
            :key="item.url || ''"
            :src="`${item.url}?format=jpeg&width=60`"
            class="object-cover w-full h-full"
            :class="{
              'opacity-80': item.index === selected.index,
            }"
            format="webp"
            width="80"
            height="80"
            :alt="item.label || ''"
            @click="onClick(item)"
          />
        </div>
      </div>
    </div>

    <ProductPageViewSlider
      v-slot="{ item }"
      :items="items"
      class="w-full h-full md:h-167"
      :active-image="selectedIndex || 0"
      @slide-change="swipeHandler"
    >
      <NuxtImg
        v-if="item.url"
        :src="item.url as string"
        class="h-full w-full mx-auto object-cover cursor-pointer rounded-[60px]"
        :alt="item.label || ''"
        format="webp"
        width="800"
        height="800"
        @click="() => onClickGalleryImage(item)"
      />
    </ProductPageViewSlider>

    <!-- <ModalDialog v-model="openGalleryView" type="large" :disable-mobile="false">
      <img :src="selectedImage" alt="" class="w-full h-full lg:max-w-lg mx-auto object-contain" />

      <button
        :area-label="$t('prev')"
        class="absolute top-1/2 transform -translate-y-1/2 left-0 w-10 h-10 lg:w-15 lg:h-15"
        :class="{ 'transform scale-x-reverse': $i18n.locale === 'ar' }"
        @click="swipePrev"
      >
        <svg-icon-arrow-left class="w-full h-full" />
      </button>

      <button
        :area-label="$t('next')"
        class="absolute top-1/2 transform -translate-y-1/2 right-0 w-10 h-10 lg:w-15 lg:h-15"
        :class="{ 'transform scale-x-reverse': $i18n.locale === 'en' }"
        @click="swipeNext"
      >
        <svg-icon-arrow-left class="w-full h-full" />
      </button>
    </ModalDialog> -->
  </div>
</template>

<script setup lang="ts">
defineComponent({
  name: 'ProductPageGallery',
});
const { product } = useProductContext();
const selected = ref({ ...product.value?.media_gallery?.[0], index: 0 });
const selectedIndex = ref<number | null>(null);
const selectedImage = ref('');
const openGalleryView = ref(false);

const items = computed(() => {
  return (
    product.value?.media_gallery
      ?.sort((a: any, b: any) => (a.position || Number.MAX_VALUE) - (b.position || Number.MAX_VALUE))
      .map((item, index) => ({ label: item?.label, url: item?.url, index })) ?? []
  );
});

watch(product, value => {
  selected.value = { ...value.media_gallery?.[0], index: 0 };
});

function onClick(item: (typeof selected)['value'] & { index: number }) {
  selected.value = item;
  selectedIndex.value = item.index;
}

function onClickGalleryImage(selected: any) {
  selectedIndex.value = items.value?.indexOf(selected) || 0;
  selectedImage.value = selected.url;
  openGalleryView.value = true;
}

function swipeHandler(itemIndex: number) {
  selectedIndex.value = itemIndex;
  selected.value = items.value[itemIndex] as (typeof selected)['value'] & { index: number };
}
</script>

<style lang="postcss" scoped>
.ProductThumbnails {
  height: 400px;
  overflow: auto;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
}
ul {
  li {
    @apply border-2 border-primary-100 cursor-pointer;
    width: 111px;
    height: 104px;
    padding: 12px;
    transition: background-color 0.2s ease-in-out;
  }
}

.ProductPageGallery {
  height: 317px;

  @screen md {
    height: 400px;

    width: 100%;
  }
}

.ProductPageGalleryWidth {
  width: calc(100vw - 40px);
  @screen md {
    width: 100%;
  }
}

.NavButton {
  &:disabled {
    @apply opacity-25 pointer-events-none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* .ProductImage {
  width: 264px;
  height: 264px;
  @screen lg {
    height: 23rem;
    width: 23rem;
  }
} */

.product-view-grid {
  @screen md {
    display: grid;
    grid-template-columns: 46px 550px;
    column-gap: 20px;
  }
}
</style>

<i18n>
{
  "en": {
    "next": "Next",
    "prev": "Previous"
  },
  "ar": {
    "next": "التالي",
    "prev": "السابق"
  }
}
</i18n>
